<template>
    <component v-model="date" :placeholder="placeholder" :inputClass="inputClass" :clearTooltip="clearTooltip"
               :is="wrap ? 'WrapperInput' : 'SingleInput'" @input="dateChanged">
        <slot></slot>
    </component>
</template>

<script>
    import Flatpickr from '../flatpickr/flatpickr'
    import BaseInput from './BaseInput'
    import SingleInput from './SingleInput.vue'
    import WrapperInput from './WrapperInput.vue'

    function Datepicker(selector, config, l10n) {
        this.l10n = Object.assign({}, Flatpickr.prototype.l10n, l10n)
        return Flatpickr.call(this, selector, config)
    }

    Datepicker.prototype = Flatpickr.prototype

    export default {
        mixins: [BaseInput],

        components: {
            SingleInput,
            WrapperInput
        },

        data () {
            return {
                datepicker: null
            }
        },

        mounted () {
            if (!this.datepicker) {
                this.config.locale.firstDayOfWeek = 1;
                this.config.locale.rangeSeparator = ' - ';

                this.datepicker = new Datepicker(this.$el, this.config, this.l10n);
                this.popupItem = this.datepicker.calendarContainer;
            }
        },

        watch: {
            config: function(newVal) {
                this.redraw(newVal);
            }
        },

        beforeDestroy () {
            if (this.datepicker && !this.static) {
                this.datepicker.destroy()
                this.datepicker = null
            }
        },

        computed: {
            wrap () {
                return !!this.config.wrap
            },
            static () {
                return !!this.config.static
            },
            name () {
                return this.wrap ? 'wrapperInput' : 'singleInput'
            }
        },

        methods: {
            redraw(newConfig) {
                this.datepicker.config = Object.assign(this.datepicker.config, newConfig);
                this.datepicker.redraw();
                //this.datepicker.jumpToDate()
            },
            dateChanged: function(newValue) {
                this.$emit('datesSelected', this.datepicker.selectedDates);
            }
        }
    }
</script>

<style lang="stylus">
    @import '~flatpickr/src/style/flatpickr'

    .flatpickr-wrapper {
        display: block;
    }
</style>



// WEBPACK FOOTER //
// index.vue?abb1ea86